import * as React from 'react';
import type {CTAWidgetPayload} from '../types';

import {BodyMedium, Button} from '@spaced-out/ui-design-system';
import css from './cta-widget.css';


interface CTAWidgetProps {
  data: CTAWidgetPayload;
  onStepClick?: (
    stepId: string,
    event: {name: string; payload: Record<string, unknown>},
  ) => void;
}

const CTAWidget = ({data, onStepClick}: CTAWidgetProps): React.ReactNode => {
  try {
    const {title = '', items = []}: CTAWidgetPayload = data;

    return (
      <div className={css.ctaWidgetContainer}>
        <BodyMedium>{title}</BodyMedium>
        <div className={css.ctaWidgetButtonsContainer}>
          {items.map((item: any) => {
            switch (item.type) {
              case 'button':
                return (
                  <Button
                    key={item.id}
                    onClick={() => {
                      //Note: will decide on this later
                      // window.open(item.url, '_blank');
                      onStepClick?.(item.id, item.event);
                    }}
                    type="tertiary"
                    isFluid={false}
                  >
                    {item.text}
                  </Button>
                );
              default:
                return null;
            }
          })}
        </div>
      </div>
    );
  } catch {
    return null;
  }
};

export default CTAWidget;
